import { Portal } from '@ark-ui/react/portal'
import { Toaster as ArkToaster, createToaster, Toast } from '@ark-ui/react/toast'
import { X } from 'lucide-react'
import { css } from '~/styled-system/css'
import { HStack, VStack } from '~/styled-system/jsx'

export const toaster: ReturnType<typeof createToaster> = createToaster({
    placement: 'top-end',
    overlap: false,
    gap: 12,
    max: 3,
})

export function Toaster() {
    return (
        <Portal>
            <ArkToaster toaster={toaster}>
                {(toast) => (
                    <Toast.Root
                        key={toast.id}
                        className={css({
                            w: 'sm',
                            borderRadius: 'xl',
                            borderWidth: '1px',
                            boxShadow: 'lg',
                            p: '4',
                            bg: 'white',
                            borderColor: 'slate.200',
                            zIndex: 'toast',
                            '&[data-type="success"]': {
                                borderColor: 'green.300',
                                bg: 'green.50',
                            },
                            '&[data-type="error"]': {
                                borderColor: 'red.300',
                                bg: 'red.50',
                            },
                            '&[data-type="warning"]': {
                                borderColor: 'yellow.300',
                                bg: 'yellow.50',
                            },
                            '&[data-type="info"]': {
                                borderColor: 'blue.300',
                                bg: 'blue.50',
                            },
                        })}
                    >
                        <HStack justify="space-between" alignItems="start" gap="3">
                            <VStack alignItems="start" gap="1" flex="1">
                                <Toast.Title className={css({ fontWeight: 'semibold', color: 'fg.default' })}>{toast.title}</Toast.Title>
                                <Toast.Description className={css({ fontSize: 'sm', color: 'fg.muted' })}>
                                    {toast.description}
                                </Toast.Description>
                            </VStack>
                            <Toast.CloseTrigger
                                className={css({
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    p: '1',
                                    borderRadius: 'md',
                                    color: 'fg.muted',
                                    _hover: { bg: 'black.a1', color: 'fg.default' },
                                })}
                                aria-label="Close notification"
                            >
                                <X size={14} />
                            </Toast.CloseTrigger>
                        </HStack>
                    </Toast.Root>
                )}
            </ArkToaster>
        </Portal>
    )
}
